import angular from 'angular';
import { SharedAngular } from '@Client/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';

export class LibraryService {
  public get emptyStateBody() {
    return (
      'Get started and create your first Flow Model.' +
      '<br />Choose to publish as a Process Map that can be viewed and shared with your team.' +
      '<br />Alternatively, include powerful automation, publish as a Workflow and start running your processes.'
    );
  }

  constructor(
    private tempModelerUrlService: SharedAngular.TempModelerUrlService
  ) {}
  openProcessMap(flowModelId: Guid) {
    this.tempModelerUrlService.openLinkInNewTab(`/processmaps/${flowModelId}`);
  }
}

angular
  .module('flowingly.runner.services')
  .factory('libraryService', [
    'tempModelerUrlService',
    (tempModelerUrlService) => new LibraryService(tempModelerUrlService)
  ]);

export type LibraryServiceType = InstanceType<typeof LibraryService>;
